import { alpha as a, lightness as l, lighten as themeUiLighten, } from '@theme-ui/color';
/**
 * Set the transparency of the color to provided value from 0-1.
 *
 * Returns the provided color if the transparency cannot be adjusted.
 */
export var alpha = function (color, alpha) {
    return function (theme) {
        try {
            return a(color, alpha)(theme);
        }
        catch (_a) {
            return color;
        }
    };
};
/**
 * Set the lightness of the color to provided value from 0-1
 *
 * Returns the provided color if the lightness cannot be adjusted.
 */
export var lightness = function (color, lightness) {
    return function (t) {
        try {
            return l(color, lightness)(t);
        }
        catch (_a) {
            return color;
        }
    };
};
/**
 * Lighten the color by the provided amount from 0-1
 *
 * Returns the provided color if the lightness cannot be adjusted.
 */
export var lighten = function (color, lighten) {
    return function (t) {
        try {
            return themeUiLighten(color, lighten)(t);
        }
        catch (_a) {
            return color;
        }
    };
};
